import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import SynthesizeImage from './SynthesizeImage'

const copy = {
  overline: `Synthesize`,
  heading: `How you synthesize your customer data`,
  description: `Synthesis is about turning data points into insights. Best-in-class synthesis means you can achieve a complete view of your customer, make accurate, trusted, audiences and customer profiles accessible to all teams, and generate insights from the data.`,
}

const Synthesize = () => (
  <SectionBase variant="2Col" reverse={true} copyVariant="narrow">
    <SectionCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Overline>{copy.overline}</CopyText.Overline>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        <CopyText.Description variant="pLarge" tag="p">
          {copy.description}
        </CopyText.Description>
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <SynthesizeImage />
    </Section.Contents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
  }
`

export default Synthesize
